$shm_ba_filter_list $mol_view
	table null
	filter? *
	status* \on
	search_query? \
	visible_count? 10
	sub <= row_views /
		<= All $mol_check_box
			title \Все
			checked? <=> all_checked? true
		<= Actions $mol_view
			sub <= action_buttons /
	More $mol_button_minor
		title \Еще
		click? <=> more? null
	Collapse $mol_button_minor
		title \Свернуть
		click? <=> collapse? null
	Item* $shm_ba_filter_item
		title <= item_title* \
		count <= item_count* \
		status <= status* \on
		highlight <= search_query? \
		checked? <=> item_checked*? true
		exclude? <=> item_exclude*? null
		only? <=> item_only*? null
